import { Database } from '@vuex-orm/core';
import ActiveImage from '@/image/ActiveImage';
import Category from '@/category/Category';
import Icon from '@/image/Icon';
import InactiveImage from '@/image/InactiveImage';
import Location from '@/location/Location';
import MapImage from '@/image/MapImage';
import Marker from '@/marker/Marker';
import MarkerImage from '@/image/MarkerImage';
import Study from '@/study/Study';
import StudyImage from '@/image/StudyImage';

const database = new Database();

database.register(ActiveImage);
database.register(Category);
database.register(Icon);
database.register(InactiveImage);
database.register(Location);
database.register(MapImage);
database.register(Marker);
database.register(MarkerImage);
database.register(Study);
database.register(StudyImage);

export default database;
